import { useCallback } from 'react'
import { useSignMessage } from 'wagmi'

import { useConfirmDialog } from '@/components/confirm-dialog'
import { Button } from '@/components/ui/button'
import useLogout from '@/hooks/use-logout'
import {
  ChallengeType,
  useChallengeMutation,
  useReadMineUserQuery,
  useRemoveMineUserMutation,
} from '@/redux/user'

export default function Security() {
  const [onLogout, onConfirmLogout] = useLogout()
  const confirm = useConfirmDialog()
  const [challenge] = useChallengeMutation()
  const [removeMineUser] = useRemoveMineUserMutation()
  const { signMessageAsync } = useSignMessage()
  const { data: mineUser } = useReadMineUserQuery()
  const address = mineUser?.wallets[0]?.address

  const onDelete = useCallback(() => {
    confirm({
      title: 'Delete Account',
      description: 'To permanently delete your account, please sign the message using your connected wallet. This signature is used to verify your identity.',
      confirmVariant: 'destructive',
      confirmText: 'Delete Account',
      onConfirm: async () => {
        if (!address) return
        const { data: challengeData } = await challenge({ address, type: ChallengeType.DeleteUser })
        if (!challengeData) return
        const signedMessage = await signMessageAsync({ message: challengeData.message })
        const { error } = await removeMineUser({
          address,
          signedMessage,
        })
        if (error) {
          return
        }
        onConfirmLogout()
      },
    })
  }, [address, challenge, confirm, onConfirmLogout, removeMineUser, signMessageAsync])

  return (
    <div>
      <div className="text-lg mb-2">
        Logout
      </div>
      <div className="text-xs text-white/50 mb-6">
        Safely log out and come back whenever you&#39;re ready.
      </div>
      <Button
        onClick={onLogout}
        variant="primary"
      >
        Logout
      </Button>

      <div className="text-lg mt-16 mb-2">
        Delete Account
      </div>
      <div className="text-xs text-white/50 mb-6">
        Deleting an account is not reversible, so please proceed with caution!
      </div>
      <Button
        onClick={onDelete}
        variant="primary"
      >
        Delete Account
      </Button>
    </div>
  )
}
